import api from 'api';
import { T } from 'shared/helpers';

export const Types = {
  GET_USERS: '/user/GET_USERS',
  GET_USERS_SUCCESS: '/user/GET_USERS_SUCCESS',
  GET_USERS_FAILURE: '/user/GET_USERS_FAILURE',
  ADD_USERS: '/user/ADD_USERS',
  ADD_USERS_SUCCESS: '/user/ADD_USERS_SUCCESS',
  ADD_USERS_FAILURE: '/user/ADD_USERS_FAILURE',
  REMOVE_USER: '/user/REMOVE_USER',
  REMOVE_USER_SUCCESS: '/user/REMOVE_USER_SUCCESS',
  REMOVE_USER_FAILURE: '/user/REMOVE_USER_FAILURE',
};

/**
 * @type {{
  loading: boolean,
  error: string | null | undefined,
  data: User[],
}}
 */
const initialState = {
  data: [],
  error: undefined,
  loading: false,
};

function validate(user) {
  const errors = [];
  if (!user.name) {
    errors.push('O campo nome é obrigatório!');
  }
  if (!user.email) {
    errors.push('O campo email é obrigatório!');
  }
  if (user.id === undefined && !user.password) {
    errors.push('O campo senha é obrigatório!');
  }
  if (user.id === undefined && !user.password_confirmation) {
    errors.push('O campo confirmação da senha é obrigatório!');
  }
  if (user.id === undefined && T(user.password || {}).length < 6) {
    errors.push('O campo senha necessita de no mínimo 6 caracteres!');
  }
  if (user.password !== user.password_confirmation) {
    errors.push('O campo senha e confirmação de senha não são iguais!');
  }
  if (user.cpf && T(user.cpf || {}).length !== 11) {
    errors.push('O campo cpf precisa conter 11 caracteres!');
  }
  if (user.ddd_telefone && T(user.ddd_telefone || {}).length !== 2) {
    errors.push('O campo DDD do telefone precisa conter apenas 2 dígitos!');
  }
  if (user.ddd_celular && T(user.ddd_celular || {}).length !== 2) {
    errors.push('O campo DDD do celular precisa conter apenas 2 dígitos!');
  }
  return errors.length > 0 ? errors.join('\n') : undefined;
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_USERS:
      return { ...state, loading: true };
    case Types.GET_USERS_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case Types.GET_USERS_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case Types.ADD_USERS:
      return {
        ...state,
        loading: true,
        loadingUserUpdate: true,
        error: undefined,
      };
    case Types.ADD_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingUserUpdate: false,
        data: action.payload.data,
        error: undefined,
      };
    case Types.ADD_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        loadingUserUpdate: false,
        error: action.payload.error,
      };
    case Types.REMOVE_USER:
      return { ...state, loading: true };
    case Types.REMOVE_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case Types.REMOVE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  getUsers: () => async dispatch => {
    dispatch({ type: Types.GET_USERS });
    try {
      const response = await api.get('/users');
      dispatch({
        type: Types.GET_USERS_SUCCESS,
        payload: {
          data: response.data,
        },
      });
    } catch (e) {
      dispatch({
        type: Types.GET_USERS_FAILURE,
        payload: { error: e.message },
      });
    }
  },
  putUser: form => async (dispatch, store) => {
    dispatch({ type: Types.ADD_USERS });
    try {
      const error = validate(form);
      if (error) {
        throw new Error(error);
      }
      const updatedUser = form.id
        ? await api.put('/users/' + form.id, form, {
            headers: {
              accept: 'application/json',
            },
          })
        : await api.post('/users', form, {
            headers: {
              accept: 'application/json',
            },
          });
      dispatch({
        type: Types.ADD_USERS_SUCCESS,
        payload: {
          data: form.id
            ? [
                ...store().users.data.map(u =>
                  Number(u.id) === Number(form.id) ? updatedUser.data : u,
                ),
              ]
            : [...store().users.data, updatedUser.data],
        },
      });
    } catch (e) {
      dispatch({
        type: Types.ADD_USERS_FAILURE,
        payload: {
          error: e.response && e.response.data
            ? e.response.data.errors
              ? Object.values(e.response.data.errors).reduce(
                  (message, v) =>
                    message + (Array.isArray(v) ? v.join(',') : v) + '\n',
                  '',
                )
              : e.response.data.message
            : e.message,
        },
      });
    }
  },
  deleteUser: id => async (dispatch, store) => {
    dispatch({ type: Types.REMOVE_USER });
    try {
      await api.delete('/users/' + id);
      dispatch({
        type: Types.REMOVE_USER_SUCCESS,
        payload: {
          data: store().users.data.filter(u => u.id !== Number(id)),
        },
      });
    } catch (e) {
      dispatch({
        type: Types.REMOVE_USER_FAILURE,
        payload: {
          error: e.message,
        },
      });
    }
  },
};
